// src/data/consultingData.js

const consultingData = [
    {
      title: 'Data Analysis',
      path: '/consulting/data-analysis',
      description:
        'Our Data Analysis consulting service provides in-depth insights into your business data, enabling informed decision-making and strategic planning.',
    },
    {
      title: 'Monitoring and Evaluation',
      path: '/consulting/monitoring-evaluation',
      description:
        'Monitoring and Evaluation consulting helps you assess the effectiveness of your programs and initiatives, ensuring they meet desired outcomes.',
    },
    {
      title: 'Business Service Consulting',
      path: '/consulting/business-service-consulting',
      description:
        'Our Business Service Consulting offers comprehensive solutions to optimize your business processes, enhancing efficiency and productivity.',
    },
    {
      title: 'Public Accounting',
      path: '/consulting/public-accounting',
      description:
        'Public Accounting consulting ensures compliance with financial regulations and provides accurate financial reporting for your organization.',
    },
    {
      title: 'Financial Systems and Modelling',
      path: '/consulting/financial-systems-modelling',
      description:
        'We offer Financial Systems and Modelling consulting to design robust financial systems and predictive models that drive business growth.',
    },
    {
      title: 'Information Security and Data Governance',
      path: '/consulting/information-security-data-governance',
      description:
        'Our Information Security and Data Governance consulting services protect your data assets and ensure regulatory compliance.',
    },
    {
      title: 'Financial Services Consulting',
      path: '/consulting/financial-services-consulting',
      description:
        'Financial Services Consulting provides strategic financial planning and advisory services tailored to your business needs.',
    },
    {
      title: 'Audit',
      path: '/consulting/audit',
      description:
        'Our Audit consulting service provides independent verification of business practices and financial records to ensure compliance and transparency.',
    },
  ];
  
  export default consultingData;
